<input
  matInput
  [type]="'text'"
  [formControl]="dateControl"
  [ngxMatDatetimePicker]="picker"
  name="datetime"
  [min]="minDate"
  [max]="maxDate"
  (focus)="updateMinMax()"
/>
<mat-datepicker-toggle (click)="updateMinMax()" matSuffix [for]="picker"></mat-datepicker-toggle>
<ngx-mat-datetime-picker
  [enableMeridian]="false"
  #picker
  style="z-index: 3000"
  [panelClass]="to.panelClass"
>
  <ng-template>
    <span>{{ 'common.ok' | t }}</span>
  </ng-template>
</ngx-mat-datetime-picker>
